var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"px-5",attrs:{"color":"error","depressed":"","dark":"","height":"40"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-trash-can-outline")]),_vm._v(" "+_vm._s(_vm.$t("warehouse.write-off-product"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }